import { render, staticRenderFns } from "./AtualizarEmpresa.vue?vue&type=template&id=017a2088"
import script from "./AtualizarEmpresa.vue?vue&type=script&lang=js"
export * from "./AtualizarEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports